import store from '@/store'
import { getTimeOffIndexRoute } from '@/router/sectionRouteUtils'

export default {
  name: 'timeoff',
  label: 'Time Off',
  link: 'timeoff',
  path: 'timeoff',
  props: true,
  icon: 'umbrella-beach',
  description: 'View and edit worker time off entries and requests.',
  component: () => import('./TimeOffLayout.vue'),
  requirePerm: 'manage_pto',
  requireFeature: 'pto',
  require: (state, getters) => getters.timeOffEnabled || state.permissions.includes('edit_settings'),
  breadcrumbLeaf: true,
  children: [
    {
      name: 'timeoff-entries',
      navIcon: 'List',
      description: 'Time off taken and scheduled.',
      label: 'Entries',
      icon: 'list',
      title: 'Time Off Entries',
      path: 'entries/:view?',
      requireGetter: 'timeOffEnabled',
      component: () => import('./TimeOffEntries.vue')
    },
    {
      name: 'timeoff-holidays',
      navIcon: 'CalendarCheck',
      description: 'Company holidays and who gets them.',
      label: 'Holidays',
      icon: 'calendar-check',
      title: 'Holidays',
      path: 'holidays',
      requireGetter: 'timeOffEnabled',
      requirePerm: 'edit_settings',
      component: () => import('./holidays/Holidays.vue')
    },
    {
      name: 'timeoff-requests',
      navIcon: 'Inbox',
      description: 'Approve or deny workers\' time off requests.',
      label: 'Requests',
      icon: 'envelope-open-text',
      title: 'Time Off Requests',
      path: 'requests/:view?',
      requireGetter: 'timeOffEnabled',
      component: () => import('./TimeOffRequests.vue')
    },
    {
      name: 'timeoff-settings',
      label: 'Settings',
      icon: 'cog',
      title: 'Time Off Settings',
      path: 'settings',
      component: () => import('@/components/TabPanel.vue'),
      requirePerm: 'edit_settings',
      children: [
        {
          name: 'timeoff-defaults',
          navIcon: 'SlidersHorizontal',
          label: 'Defaults',
          icon: 'sliders',
          title: 'Time Off Defaults',
          path: 'defaults',
          component: () => import('@/modules/timeoff/TimeOffDefaults.vue')
        },
        {
          name: 'timeoff-codes',
          navIcon: 'CalendarPlus',
          label: 'Time Off Codes',
          icon: 'calendar-plus',
          path: 'codes',
          requireGetter: 'timeOffEnabled',
          component: () => import('@/modules/timeoff/TimeOffCodeList.vue')
        },
        {
          name: 'timeoff-policies',
          navIcon: 'ScrollText',
          label: 'Policies',
          icon: 'scroll',
          title: 'Time Off Policies',
          path: 'policies',
          requireGetter: 'timeOffAccrualEnabled',
          component: () => import('@/modules/timeoff/TimeOffPolicies.vue')
        },
        {
          name: 'timeoff-settings-index',
          path: '',
          redirect: { name: 'timeoff-defaults' }
        }
      ]
    },
    {
      name: 'timeoff-index',
      path: '',
      nav: false,
      // beforeEnter (unlike redirect) runs after the router has waited for app state to load, so this
      // reads accurate feature/permission state instead of racing it on a hard page load (e.g. new tab).
      beforeEnter: to => ({ name: getTimeOffIndexRoute(store.state, store.getters), params: to.params })
    }
  ]
}
